import gsap, { Expo, Power1, Power2, Power3 } from "gsap";

import { GetBy } from "../_app/cuchillo/core/Element";
import { isDebug } from "../_app/cuchillo/core/Basics";
import CircleVisor from "./CircleVisor";

export default class Preloader {
    _container;
    _items;

    static init () {
        this._container = GetBy.id('Preloader');
        this._items = GetBy.selector('span', this._container);
        this._title = GetBy.class('title', this._container)[0];
       
        if(isDebug) this._container.style.display = "none"; 
    }

    static show(__call) {
        if(isDebug) {
            if(__call) __call();
            return;
        }
        
        for(let i = 0, j= this._items.length; i<j; i++) {
             gsap.to(this._items[i], { opacity: 1, ease: Power3.easeOut, duration: 1.8 + .1  * i, delay: .1 + .05 * i});
        }
       
        setTimeout(()=> {
            __call();
        }, 100)
    }

    static update (__progress) {
        gsap.killTweensOf(this._progress);
        gsap.to(this._progress, {
            scaleX: __progress,
            ease: Power1.easeOut,
            duration: .1
        });
    }

    static hide (__call) {
        if(isDebug) {
            if(__call) __call();
            return;
        }
        
         gsap.to(CircleVisor, {
            preloadProgress: 1,
            ease: Expo.easeInOut,
            duration: 4,
            delay:0,
            onComplete: ()=> {
                this._container.style.display = "none";
                __call();
                CircleVisor.isHide = false;
                CircleVisor.isPreload = false;
            }
        });

        for(let i = 0, j= this._items.length; i<j; i++) {
             gsap.to(this._items[i], { opacity: 0, ease: Power3.easeIn, duration: .4, delay: 2 + .01 * i});
        }
        //__call();
        //    return;
       // if(isDebug) {
        gsap.to(this._container, {
            //alpha: 0,
            duration: .2,
            opacity: 0,
            delay: 3,
            ease: Power2.easeIn,
            onComplete: () => {
                
            }
        });
    }
}
